// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress_bar {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin-top: -20px;
    counter-reset: progress 0;
    text-align: center;
    color: #b6b6b9;
    font-weight: 900 !important;
    font-size: 14px
}

.progress_bar li {
    position: relative;
    counter-increment: progress 1
}

.progress_bar li::before {
    position: absolute;
    content: counter(progress);
    height: 30px;
    width: 30px;
    color: #eee;
    border: 1px solid #eee;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -40px;
    left: 12px;
    z-index: 2;
    background-color: #fff;
    transition:all 1s;
}

.progress_bar li:nth-child(1)::before {
    background-color: #fe3643
}
 
.progress_bar li:nth-child(1) {
    color: #fe3643;
    font-weight: 800 !important
}

.progress_bar li::after {
    position: absolute;
    content: '';
    width: 160px;
    height: 4px;
    background-color: #eeeeee;
    left: -120px;
    top: -25px;
    transition:all 0.5s;
}

.progress_bar li:nth-child(1)::after {
    display: none;
}

.progress_bar li.active {
    color: #7AC142 !important;
    font-weight: 800 !important;
}

.progress_bar li.active::before {
    background-color: #7AC142!important;
    color: #fff !important;
}

.progress_bar li.active::after {
    background-color: #7AC142 !important;
}

.warning {
    border: 1px solid red !important;
}

.m_top {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.m_top p {
    margin-top: 10px;
    color: #999999;
    font-size: 14px;
    text-align: center;
}

.m_top h3 {
    color: #7c7c7c;
}

.mt {
    margin-top: 249px !important;
}

.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7AC142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards
}

.checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7AC142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0
    }
}

@keyframes scale {

    0%,
    100% {
        transform: none
    }

    50% {
        transform: scale3d(1.1, 1.1, 1)
    }
}

@keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px #7AC142
    }
}
.custom-margin-bottom {
    margin-bottom: 100px;
}
.center-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  /* avatar */
 
.avatar-padding-top {
    padding-top: 40px; /* Ajustez la valeur selon vos besoins */
}

.btn-ai {
    background-color: #007BFF; /* Blue color for AI theme */
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/css/Register.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,qCAAqC;IACrC;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;EACtB;EACA,WAAW;;AAEb;IACI,iBAAiB,EAAE,wCAAwC;AAC/D;;AAEA;IACI,yBAAyB,EAAE,4BAA4B;IACvD,YAAY;AAChB","sourcesContent":[".progress_bar {\r\n    list-style: none;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: -20px;\r\n    counter-reset: progress 0;\r\n    text-align: center;\r\n    color: #b6b6b9;\r\n    font-weight: 900 !important;\r\n    font-size: 14px\r\n}\r\n\r\n.progress_bar li {\r\n    position: relative;\r\n    counter-increment: progress 1\r\n}\r\n\r\n.progress_bar li::before {\r\n    position: absolute;\r\n    content: counter(progress);\r\n    height: 30px;\r\n    width: 30px;\r\n    color: #eee;\r\n    border: 1px solid #eee;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    top: -40px;\r\n    left: 12px;\r\n    z-index: 2;\r\n    background-color: #fff;\r\n    transition:all 1s;\r\n}\r\n\r\n.progress_bar li:nth-child(1)::before {\r\n    background-color: #fe3643\r\n}\r\n \r\n.progress_bar li:nth-child(1) {\r\n    color: #fe3643;\r\n    font-weight: 800 !important\r\n}\r\n\r\n.progress_bar li::after {\r\n    position: absolute;\r\n    content: '';\r\n    width: 160px;\r\n    height: 4px;\r\n    background-color: #eeeeee;\r\n    left: -120px;\r\n    top: -25px;\r\n    transition:all 0.5s;\r\n}\r\n\r\n.progress_bar li:nth-child(1)::after {\r\n    display: none;\r\n}\r\n\r\n.progress_bar li.active {\r\n    color: #7AC142 !important;\r\n    font-weight: 800 !important;\r\n}\r\n\r\n.progress_bar li.active::before {\r\n    background-color: #7AC142!important;\r\n    color: #fff !important;\r\n}\r\n\r\n.progress_bar li.active::after {\r\n    background-color: #7AC142 !important;\r\n}\r\n\r\n.warning {\r\n    border: 1px solid red !important;\r\n}\r\n\r\n.m_top {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.m_top p {\r\n    margin-top: 10px;\r\n    color: #999999;\r\n    font-size: 14px;\r\n    text-align: center;\r\n}\r\n\r\n.m_top h3 {\r\n    color: #7c7c7c;\r\n}\r\n\r\n.mt {\r\n    margin-top: 249px !important;\r\n}\r\n\r\n.checkmark__circle {\r\n    stroke-dasharray: 166;\r\n    stroke-dashoffset: 166;\r\n    stroke-width: 2;\r\n    stroke-miterlimit: 10;\r\n    stroke: #7AC142;\r\n    fill: none;\r\n    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards\r\n}\r\n\r\n.checkmark {\r\n    width: 56px;\r\n    height: 56px;\r\n    border-radius: 50%;\r\n    display: block;\r\n    stroke-width: 2;\r\n    stroke: #fff;\r\n    stroke-miterlimit: 10;\r\n    margin: 10% auto;\r\n    box-shadow: inset 0px 0px 0px #7AC142;\r\n    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both\r\n}\r\n\r\n.checkmark__check {\r\n    transform-origin: 50% 50%;\r\n    stroke-dasharray: 48;\r\n    stroke-dashoffset: 48;\r\n    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards\r\n}\r\n\r\n@keyframes stroke {\r\n    100% {\r\n        stroke-dashoffset: 0\r\n    }\r\n}\r\n\r\n@keyframes scale {\r\n\r\n    0%,\r\n    100% {\r\n        transform: none\r\n    }\r\n\r\n    50% {\r\n        transform: scale3d(1.1, 1.1, 1)\r\n    }\r\n}\r\n\r\n@keyframes fill {\r\n    100% {\r\n        box-shadow: inset 0px 0px 0px 30px #7AC142\r\n    }\r\n}\r\n.custom-margin-bottom {\r\n    margin-bottom: 100px;\r\n}\r\n.center-button {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n  }\r\n  /* avatar */\r\n \r\n.avatar-padding-top {\r\n    padding-top: 40px; /* Ajustez la valeur selon vos besoins */\r\n}\r\n\r\n.btn-ai {\r\n    background-color: #007BFF; /* Blue color for AI theme */\r\n    color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
